import React from 'react';
import Dropzone from 'react-dropzone';

import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import AddPhotoAlternateIcon from '@material-ui/icons/AddPhotoAlternate';
import ClearRoundedIcon from '@material-ui/icons/ClearRounded';
import DoneRoundedIcon from '@material-ui/icons/DoneRounded';
import classnames from 'classnames';
import { MAX_ATTACHMENT_FILE_SIZE_IN_BYTES } from 'constants/environment';

import TaskInfo from 'pages/Students/Assignments/Detail/components/TaskInfo/index';
import WebcamTips from 'pages/Students/Assignments/Detail/components/WebcamTips';

import Timer from 'components/Timer';

import styles from './styles.module.scss';

const whiteIcon = withStyles({
  root: {
    color: 'var(--white)',
    fontSize: '3rem'
  }
});

const StyledDoneIcon = whiteIcon(DoneRoundedIcon);
const StyledClearIcon = whiteIcon(ClearRoundedIcon);

const CaptureControls = ({
  isMobile,
  previewImage,
  uploadedImageBlob,
  croppingActive,
  startTimer,
  documentScanActive,
  documentScanCancelled,
  activeTask,
  taskImagePreview,
  qualityErrorMessage,
  containerRef,
  onDrop,
  onCapture,
  onTimerFinish,
  onCrop,
  onRemovePhoto,
  onUploadPhoto,
  onRemoveSavedBlob,
  onUploadSavedBlob
}) => {
  return (
    <div className={styles.taskNavigation} ref={containerRef}>
      <WebcamTips previewImage={previewImage} />
      <div className={styles.buttonsWrapper}>
        {!previewImage && !documentScanCancelled && (
          <Dropzone
            onDrop={onDrop}
            maxSize={MAX_ATTACHMENT_FILE_SIZE_IN_BYTES}
            accept={['image/jpeg', 'image/png']}
          >
            {({ getRootProps, getInputProps }) => (
              <div className={styles.uploadButton} {...getRootProps()}>
                <input {...getInputProps()} />
                <IconButton>
                  <AddPhotoAlternateIcon color="primary" fontSize="large" />
                </IconButton>
              </div>
            )}
          </Dropzone>
        )}

        {!previewImage && !documentScanActive && (
          <div
            className={classnames(styles.cameraBtn, styles.screenshot)}
            onClick={onCapture}
          >
            {startTimer && !isMobile && (
              <Timer seconds={1} showDigits={false} onFinish={onTimerFinish} />
            )}
          </div>
        )}

        {previewImage && croppingActive && (
          <div className={styles.confirmDeleteButtons}>
            <div
              className={classnames(styles.cameraBtn, styles.confirm)}
              onClick={onCrop}
            >
              <StyledDoneIcon />
            </div>
          </div>
        )}

        {previewImage && !uploadedImageBlob && !croppingActive && (
          <div className={styles.confirmDeleteButtons}>
            <div
              className={classnames(styles.cameraBtn, styles.delete)}
              onClick={onRemovePhoto}
            >
              <StyledClearIcon />
            </div>
            {qualityErrorMessage === null && (
              <div
                className={classnames(styles.cameraBtn, styles.confirm)}
                onClick={onUploadPhoto}
              >
                <StyledDoneIcon />
              </div>
            )}
          </div>
        )}

        {previewImage && uploadedImageBlob && !croppingActive && (
          <div className={styles.confirmDeleteButtons}>
            <div
              className={classnames(styles.cameraBtn, styles.delete)}
              onClick={onRemoveSavedBlob}
            >
              <StyledClearIcon />
            </div>
            <div
              className={classnames(styles.cameraBtn, styles.confirm)}
              onClick={onUploadSavedBlob}
            >
              <StyledDoneIcon />
            </div>
          </div>
        )}
      </div>
      {!documentScanCancelled && (
        <TaskInfo task={activeTask} img={taskImagePreview} />
      )}
    </div>
  );
};

export default CaptureControls;
